import { render, staticRenderFns } from "./NotData.vue?vue&type=template&id=2f5c313f&scoped=true"
import script from "./NotData.vue?vue&type=script&lang=js"
export * from "./NotData.vue?vue&type=script&lang=js"
import style0 from "./NotData.vue?vue&type=style&index=0&id=2f5c313f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c313f",
  null
  
)

export default component.exports